export default __webpack_public_path__ + "static/d2infuse-1a8969.png";